import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceArea,
} from "recharts";
import { LineChart as LineIcon } from "lucide-react";

export default function LabChartsGrid({ patientId }) {
  const [trends, setTrends] = useState({});

  useEffect(() => {
    api.get(`/patients/${patientId}/trends`).then((r) => setTrends(r.data));
  }, [patientId]);

  const keys = Object.keys(trends);
  if (keys.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        Sem exames laboratoriais registrados para gerar gráficos.
      </p>
    );
  }

  return (
    <div className="grid sm:grid-cols-2 gap-4" data-testid="lab-charts-grid">
      {keys.map((k) => {
        const s = trends[k];
        const data = (s.points || []).map((p) => ({ date: p.date, valor: p.value }));
        const last = s.points[s.points.length - 1];
        const out = last && last.status !== "normal";
        return (
          <Card key={k} className="p-4 border-border shadow-none" data-testid={`lab-chart-${k}`}>
            <div className="flex items-center justify-between mb-2">
              <h5 className="text-sm font-medium flex items-center gap-2">
                <LineIcon className="w-3.5 h-3.5 text-ai" /> {s.label}
              </h5>
              <span className={`font-mono-data text-sm ${out ? "text-destructive" : "text-success"}`}>
                {last?.value} {s.unit}
              </span>
            </div>
            <ResponsiveContainer width="100%" height={160}>
              <LineChart data={data} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                <XAxis dataKey="date" stroke="hsl(var(--muted-foreground))" fontSize={10} />
                <YAxis stroke="hsl(var(--muted-foreground))" fontSize={10} width={34} />
                <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }} />
                <ReferenceArea y1={s.ref_min} y2={s.ref_max} fill="hsl(var(--success))" fillOpacity={0.08} />
                <Line type="monotone" dataKey="valor" stroke="hsl(var(--chart-2))" strokeWidth={2} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
            <p className="text-[11px] text-muted-foreground mt-1">
              Ref: {s.ref_min}–{s.ref_max} {s.unit} · {s.points.length} medição(ões)
            </p>
          </Card>
        );
      })}
    </div>
  );
}
